// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"FullPizza","810":"NotFound","965":"Cart"}[chunkId] + "." + {"102":"08505359","810":"d1cfbc11","965":"beb12625"}[chunkId] + ".chunk.js";
};